// src/plugins/native-exif.js
import { registerPlugin } from '@capacitor/core';

// This creates the JS proxy that talks to your Android plugin class
const NativeExif = registerPlugin('NativeExif');

// Expose for DevTools / global access
if (typeof window !== 'undefined') {
  window.NativeExif = NativeExif;
}

export default NativeExif;
export { NativeExif };
